/* =============================================================================
   IRREAL — Upsell inteligente do Cart Drawer
   -----------------------------------------------------------------------------
   O que este arquivo faz:
   1) Lê o estado do carrinho (sabores + quantidades) e a meta de recompensa
      (ex.: 20 snacks = 15% OFF + Frete Grátis) direto da config da barra de
      progressão — uma única fonte de verdade.
   2) Monta um "plano" de sugestões priorizadas:
        - 1º: o SABOR OPOSTO ao dominante, na MESMA quantidade do carrinho
              (ou na quantidade que COMPLETA a recompensa, quando der).
        - 2º: o mesmo sabor oposto em quantidade maior (mais perto/garante o desconto).
        - 3º: variedade (Degustação) como reforço.
   3) Reescreve a cópia de cada card conectando à recompensa
      ("Complete 20 e desbloqueie 15% OFF + Frete Grátis" / "Faltam X un...").
   4) Ajusta a QUANTIDADE que cada botão adiciona (não é mais fixo em 6).
   5) Corrige os bugs:
        - setas do carrossel (delegação de evento, nunca mais "listener morto");
        - re-render coordenado e único (sem corrida com o tema → carrinho reabre ok);
        - sem loop de refetch.
============================================================================= */
(function initIrrealUpsell() {
  if (window.__IRREAL_UPSELL__) return;
  window.__IRREAL_UPSELL__ = true;

  var BUNDLE_FALLBACK = [6, 10, 20];

  // ---- estado interno (evita corridas) -------------------------------------
  var rendering = false;   // true enquanto reescrevemos o #CartDrawer-Upsell
  var syncing = false;     // mutex do refresh coordenado
  var syncQueued = false;  // pedido de refresh chegou durante um sync
  var applyTimer = null;

  // ---- helpers --------------------------------------------------------------
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function toInt(v) {
    var n = parseInt(String(v == null ? '' : v).trim(), 10);
    return isFinite(n) ? n : null;
  }

  function moneyBR(cents) {
    var v = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
    } catch (e) {
      return 'R$ ' + v.toFixed(2).replace('.', ',');
    }
  }

  function cardTiers(card) {
    var t = [card.dataset.bqQ1, card.dataset.bqQ2, card.dataset.bqQ3]
      .map(toInt).filter(function (n) { return n && n > 0; });
    if (!t.length) return BUNDLE_FALLBACK.slice();
    return t.sort(function (a, b) { return a - b; });
  }

  // preço por unidade considerando as faixas de volume (quantity_price_breaks)
  function unitPriceForQty(card, qty) {
    var base = toInt(card.dataset.basePrice) || 0;
    var tiers = [];
    try { tiers = JSON.parse(card.dataset.tierPrices || '[]') || []; } catch (e) { tiers = []; }
    var price = base;
    tiers
      .sort(function (a, b) { return a.min - b.min; })
      .forEach(function (b) { if (qty >= b.min) price = b.price; });
    return price; // em centavos
  }

  // ---- meta de recompensa (lida da barra de progressão) --------------------
  function readRewardGoal() {
    var cfg = $('[data-apx-cart-progress-config]');
    var goal = { metric: 'quantity', threshold: 20, title: '15% OFF + Frete Grátis' };
    if (!cfg) return goal;

    var settings = {}, tiers = [];
    try { settings = JSON.parse($('[data-apx-cart-progress-settings]', cfg).textContent || '{}'); } catch (e) {}
    try { tiers = JSON.parse($('[data-apx-cart-progress-tiers]', cfg).textContent || '[]') || []; } catch (e) {}

    var metric = settings.mode === 'money' ? 'money'
      : settings.mode === 'quantity' ? 'quantity'
      : (tiers[0] && tiers[0].metric) || 'quantity';

    var chain = tiers.filter(function (t) { return t && t.metric === metric; });
    if (!chain.length) return goal;

    chain.sort(function (a, b) {
      var ta = metric === 'money' ? Number(a.threshold) * 100 : Number(a.threshold);
      var tb = metric === 'money' ? Number(b.threshold) * 100 : Number(b.threshold);
      return ta - tb;
    });
    var top = chain[chain.length - 1];
    goal.metric = metric;
    goal.threshold = metric === 'money' ? Math.round(Number(top.threshold) * 100) : Number(top.threshold);
    goal.title = (top.benefit_title || goal.title).trim();
    return goal;
  }

  // ---- leitura do carrinho --------------------------------------------------
  function flavorOf(handle) {
    var h = String(handle || '').toLowerCase();
    if (h.indexOf('paprica') >= 0) return 'paprica';
    if (h.indexOf('alho') >= 0) return 'alho';
    if (h.indexOf('degustacao') >= 0) return 'degustacao';
    return 'other';
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function analyze(cart) {
    var a = { total: 0, byFlavor: { paprica: 0, alho: 0, degustacao: 0, other: 0 }, dominant: null };
    if (!cart || !cart.items) return a;
    cart.items.forEach(function (it) {
      var f = flavorOf(it.handle || (it.product && it.product.handle));
      a.total += Number(it.quantity || 0);
      a.byFlavor[f] = (a.byFlavor[f] || 0) + Number(it.quantity || 0);
    });
    // sabor dominante = single (páprica/alho) com maior qtd; senão degustação
    var singles = ['paprica', 'alho'].filter(function (f) { return a.byFlavor[f] > 0; });
    if (singles.length) {
      singles.sort(function (x, y) { return a.byFlavor[y] - a.byFlavor[x]; });
      a.dominant = singles[0];
    } else if (a.byFlavor.degustacao > 0) {
      a.dominant = 'degustacao';
    }
    return a;
  }

  var OPPOSITE = { paprica: 'alho', alho: 'paprica' };

  // escolhe, entre os tiers do card, o que completa exatamente a meta
  function tierThatCompletes(tiers, total, threshold) {
    for (var i = 0; i < tiers.length; i++) if (total + tiers[i] === threshold) return tiers[i];
    return null;
  }
  // menor tier que atinge/ultrapassa a meta
  function tierThatReaches(tiers, total, threshold) {
    for (var i = 0; i < tiers.length; i++) if (total + tiers[i] >= threshold) return tiers[i];
    return null;
  }
  // espelha a qtd dominante para um tier válido do card
  function mirrorTier(tiers, mirror) {
    if (tiers.indexOf(mirror) >= 0) return mirror;
    var best = tiers[0];
    tiers.forEach(function (t) { if (Math.abs(t - mirror) < Math.abs(best - mirror)) best = t; });
    return best;
  }
  function nextTierAbove(tiers, q) {
    for (var i = 0; i < tiers.length; i++) if (tiers[i] > q) return tiers[i];
    return tiers[tiers.length - 1];
  }

  // ---- plano de sugestões ---------------------------------------------------
  // Retorna lista ordenada de { card, qty, headline, reward }
  function buildPlan(cardsByFlavor, analysis, goal) {
    var plan = [];
    var F = goal.threshold;
    var title = goal.title;
    var qtyMetric = goal.metric === 'quantity';
    var total = analysis.total;
    var remaining = Math.max(0, F - total);

    function push(card, qty, headline, reward) {
      if (!card || !qty) return;
      if (card.dataset.unavailable === 'true') return;
      // evita duplicar exatamente o mesmo card+qtd
      for (var i = 0; i < plan.length; i++) {
        if (plan[i].card === card && plan[i].qty === qty) return;
      }
      plan.push({ card: card, qty: qty, headline: headline, reward: !!reward });
    }

    var dom = analysis.dominant;
    var degCard = cardsByFlavor.degustacao;

    if (dom === 'paprica' || dom === 'alho') {
      var opp = OPPOSITE[dom];
      var oppCard = cardsByFlavor[opp];
      var mirror = analysis.byFlavor[dom] || 6; // qtd atual do sabor dominante
      var oppInCart = (analysis.byFlavor[opp] || 0) > 0;

      if (oppCard) {
        var tiers = cardTiers(oppCard);
        var mq = mirrorTier(tiers, mirror);

        if (qtyMetric && remaining > 0) {
          var complete = tierThatCompletes(tiers, total, F);
          if (complete) {
            // 1 clique fecha a recompensa
            push(oppCard, complete, 'Falta pouco! Complete ' + F + ' e ganhe ' + title, true);
            // alternativa: mesma qtd do carrinho (variedade)
            if (mq !== complete) push(oppCard, mq, 'Leve o outro sabor também', false);
          } else {
            // 1º: sabor oposto na MESMA quantidade do carrinho
            var h1 = oppInCart
              ? ('Faltam só ' + remaining + ' un para ' + title + ' — complete agora')
              : ('Que tal variar? Leve o outro sabor — faltam ' + remaining + ' un p/ ' + title);
            push(oppCard, mq, h1, false);
            // 2º: a próxima faixa (mais unidades → mais perto / garante o desconto)
            var moreQ = nextTierAbove(tiers, mq);
            var reachReward = (total + moreQ) >= F;
            if (moreQ !== mq) {
              push(oppCard, moreQ,
                reachReward ? ('Garanta agora: ' + title) : 'Leve mais e pague menos por unidade',
                reachReward);
            }
          }
        } else {
          // recompensa já atingida (ou métrica em R$): foco em variedade
          push(oppCard, tiers[0], 'Aproveite e leve o outro sabor também', false);
        }
      }

      // 3º: Degustação como variedade/presente
      if (degCard) {
        var dt = cardTiers(degCard);
        push(degCard, dt[0], 'Leve os dois sabores no Kit Degustação', false);
      }
    } else if (dom === 'degustacao') {
      // só degustação no carrinho → oferecer sabores puros
      ['paprica', 'alho'].forEach(function (f, idx) {
        var c = cardsByFlavor[f];
        if (!c) return;
        var tiers = cardTiers(c);
        if (qtyMetric && remaining > 0) {
          var comp = tierThatCompletes(tiers, total, F) || tierThatReaches(tiers, total, F);
          if (comp) {
            push(c, comp, 'Pronto pra liberar! Adicione ' + comp + ' un e ganhe ' + title, (total + comp) >= F);
          } else {
            push(c, mirrorTier(tiers, analysis.byFlavor.degustacao || 6), 'Turbine o combo com um sabor puro', false);
          }
        } else {
          push(c, tiers[0], idx === 0 ? 'Adicione o sabor Páprica' : 'Adicione o sabor Alho Poró', false);
        }
      });
    } else {
      // fallback genérico: tudo que não está no carrinho, com gancho de recompensa
      Object.keys(cardsByFlavor).forEach(function (f) {
        var c = cardsByFlavor[f];
        if (!c) return;
        var tiers = cardTiers(c);
        var comp = qtyMetric ? (tierThatCompletes(tiers, total, F) || tierThatReaches(tiers, total, F)) : null;
        if (comp) push(c, comp, 'Adicione e desbloqueie ' + title, (total + comp) >= F);
        else push(c, tiers[0], 'Adicione ao seu pedido', false);
      });
    }

    return plan.slice(0, 4);
  }

  // ---- renderização do upsell ----------------------------------------------
  var renderPass = 0;
  function renderPlan(root, plan) {
    rendering = true;
    var pass = ++renderPass;
    var track = $('.upsell__track', root);
    if (!track) { rendering = false; return; }

    // todos os cards-fonte (escondidos por padrão)
    var allCards = $all('.upsell-card', track);
    allCards.forEach(function (c) { c.hidden = true; });

    // limpa clones antigos
    $all('.upsell-card[data-clone="true"]', track).forEach(function (c) { c.remove(); });

    if (!plan.length) {
      root.hidden = true;
      rendering = false;
      return;
    }

    var usedSource = {};
    plan.forEach(function (sug) {
      var src = sug.card;
      var node;
      // se a fonte já foi usada, clonamos para mostrar a mesma oferta em outra qtd
      if (usedSource[src.dataset.handle]) {
        node = src.cloneNode(true);
        node.dataset.clone = 'true';
        node.hidden = false;
        track.appendChild(node);
      } else {
        node = src;
        usedSource[src.dataset.handle] = true;
        node.hidden = false;
      }
      decorateCard(node, sug);
      node.dataset.pass = String(pass); // carimbo desta passada
    });

    // ordena na DOM conforme o plano
    plan.forEach(function (sug) {
      var sel = '.upsell-card[data-render-key="' + cssEscape(planKey(sug)) + '"]';
      var el = $(sel, track);
      if (el) track.appendChild(el);
    });

    // 🔒 segurança: NUNCA mostrar um card "pelado".
    // Qualquer card visível que não foi decorado nesta passada fica escondido.
    $all('.upsell-card', track).forEach(function (c) {
      if (c.dataset.pass !== String(pass)) c.hidden = true;
    });

    root.hidden = false;
    updateArrows(root);
    rendering = false;
  }

  function planKey(sug) { return sug.card.dataset.handle + '_' + sug.qty; }
  function cssEscape(s) { return String(s).replace(/[^a-zA-Z0-9_-]/g, '_'); }

  function decorateCard(node, sug) {
    node.dataset.renderKey = cssEscape(planKey(sug));
    // gancho/cópia
    var hook = $('[data-upsell-hook]', node);
    if (hook) {
      hook.hidden = false;
      hook.classList.toggle('is-reward', !!sug.reward);
      hook.innerHTML = '<span class="ir-dot" aria-hidden="true"></span>' + escapeHtml(sug.headline);
    }
    node.classList.toggle('is-reward', !!sug.reward);

    // preço por unidade + total para a qtd sugerida
    var unit = unitPriceForQty(node, sug.qty);
    var priceWrap = $('[data-upsell-price]', node);
    if (priceWrap) {
      var base = toInt(node.dataset.basePrice) || unit;
      var oldHtml = base > unit ? '<s class="upsell-card__price--old">' + moneyBR(base) + '</s> ' : '';
      priceWrap.innerHTML =
        oldHtml +
        '<span class="upsell-card__price--now">' + moneyBR(unit) + '</span>' +
        '<span class="upsell-card__price--unit">/un</span>' +
        '<span class="upsell-card__price--total">' + sug.qty + ' un = ' + moneyBR(unit * sug.qty) + '</span>';
    }

    // selo de quantidade sobre a imagem (deixa MUITO claro quantas un)
    var media = $('.upsell-card__media', node);
    if (media) {
      var badge = $('.upsell-card__qty-badge', media);
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'upsell-card__qty-badge';
        media.appendChild(badge);
      }
      badge.textContent = sug.qty + ' un';
    }

    // botão: SEMPRE com a quantidade
    var btn = $('.upsell-card__add', node);
    if (btn) {
      btn.dataset.addQty = String(sug.qty);
      var label = $('[data-upsell-add-label]', btn);
      var txt = 'Adicionar ' + sug.qty + ' un';
      if (label) label.textContent = txt; else btn.textContent = txt;
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function applySmartUpsell() {
    var root = $('#CartDrawer-Upsell');
    if (!root) return Promise.resolve();
    return getCart().then(function (cart) {
      if (!cart) return;
      var goal = readRewardGoal();
      var analysis = analyze(cart);

      // mapa de cards por sabor (apenas as fontes originais, não clones)
      var cards = $all('.upsell-card:not([data-clone="true"])', root);
      var byFlavor = {};
      cards.forEach(function (c) { byFlavor[c.dataset.flavor] = byFlavor[c.dataset.flavor] || c; });

      var plan = buildPlan(byFlavor, analysis, goal);
      renderPlan(root, plan);
    });
  }

  function scheduleApply() {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(applySmartUpsell, 150);
  }

  // ---- carrossel (delegação — nunca mais listener morto) -------------------
  function updateArrows(root) {
    var track = $('.upsell__track', root);
    var prev = $('.upsell__btn--prev', root);
    var next = $('.upsell__btn--next', root);
    if (!track) return;
    var maxScroll = track.scrollWidth - track.clientWidth - 2;
    var multi = maxScroll > 4;
    if (prev) prev.disabled = !multi || track.scrollLeft <= 2;
    if (next) next.disabled = !multi || track.scrollLeft >= maxScroll;
    var nav = $('.upsell__nav', root);
    if (nav) nav.style.visibility = multi ? '' : 'hidden';
  }

  function scrollTrack(root, dir) {
    var track = $('.upsell__track', root);
    if (!track) return;
    var card = $('.upsell-card:not([hidden])', track);
    var step = card ? card.getBoundingClientRect().width + 12 : 300;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  // clique nas setas (delegado no document → sobrevive a qualquer re-render)
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.upsell__btn');
    if (!btn) return;
    var root = btn.closest('#CartDrawer-Upsell');
    if (!root) return;
    ev.preventDefault();
    scrollTrack(root, btn.classList.contains('upsell__btn--prev') ? -1 : 1);
  });

  // atualiza estado das setas ao rolar
  document.addEventListener('scroll', function (ev) {
    var track = ev.target;
    if (!track || !track.classList || !track.classList.contains('upsell__track')) return;
    var root = track.closest('#CartDrawer-Upsell');
    if (root) updateArrows(root);
  }, true);

  // ---- adicionar (qtd inteligente) + refresh coordenado --------------------
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.upsell-card__add');
    if (!btn) return;
    var root = btn.closest('#CartDrawer-Upsell');
    if (!root) return;

    ev.preventDefault();
    ev.stopPropagation();
    if (btn.__busy) return;
    btn.__busy = true;

    var variantId = toInt(btn.dataset.variantId);
    var qty = toInt(btn.dataset.addQty) || 6;
    if (!variantId) { btn.__busy = false; return; }

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty, properties: { _bundle_qty: qty } })
    })
      .then(function (r) { if (!r.ok) throw new Error('add falhou ' + r.status); return r.json(); })
      .then(function () { return syncDrawer(); })
      .catch(function (e) { console.warn('[IRREAL upsell] add', e); })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        setTimeout(function () { btn.__busy = false; }, 50);
      });
  }, true);

  // Refresh ÚNICO e coordenado dos blocos do drawer (sem corrida com o tema).
  function syncDrawer() {
    if (syncing) { syncQueued = true; return Promise.resolve(); }
    syncing = true;

    return fetch('/cart?section_id=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // troca apenas os blocos necessários, de uma vez só
        swap(doc, '#CartDrawer-CartItems');
        swap(doc, '.drawer__footer');
        swap(doc, '#CartDrawer-Upsell');
      })
      .then(function () { return applySmartUpsell(); })
      .then(function () {
        // avisa a barra de progressão (única vez)
        try { window.dispatchEvent(new CustomEvent('apx:cart-mutated')); } catch (e) {}
      })
      .catch(function (e) { console.warn('[IRREAL upsell] sync', e); })
      .finally(function () {
        syncing = false;
        if (syncQueued) { syncQueued = false; syncDrawer(); }
      });
  }

  function swap(doc, sel) {
    var neu = doc.querySelector(sel);
    var cur = document.querySelector(sel);
    if (neu && cur) cur.replaceWith(neu);
  }

  // ---- gatilhos ------------------------------------------------------------
  // 1) mutação real do carrinho (add/change/update/clear) → re-aplica upsell.
  window.addEventListener('apx:cart-mutated', scheduleApply);

  // 2) observa o drawer só para reaplicar quando o TEMA re-renderiza a gaveta
  //    (ex.: usuário usa o seletor de quantidade). Ignora nossas próprias edições.
  var moTimer = null;
  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__irrealObserved) return;
    drawer.__irrealObserved = true;

    var mo = new MutationObserver(function (muts) {
      if (rendering || syncing) return; // nossas edições — ignora
      // ignora mutações internas do próprio upsell
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('#CartDrawer-Upsell')) return;
      }
      clearTimeout(moTimer);
      moTimer = setTimeout(applySmartUpsell, 160);
    });
    mo.observe(drawer, { childList: true, subtree: true });

    drawer.addEventListener('transitionend', function () {
      scheduleApply();
      var root = $('#CartDrawer-Upsell');
      if (root) updateArrows(root);
    });
  }

  function boot() {
    observeDrawer();
    applySmartUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // editor de tema
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && String(e.detail.sectionId || '').indexOf('cart-drawer') >= 0) {
      observeDrawer();
      scheduleApply();
    }
  });

  // reavalia setas no resize
  window.addEventListener('resize', function () {
    var root = $('#CartDrawer-Upsell');
    if (root) updateArrows(root);
  });
})();
